import * as React from "react";
import type { SVGProps } from "react";
const SvgArrowCurveUpLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M4.2 8.914 9.514 3.6m0 0 5.314 5.314M9.514 3.6v12.8a4 4 0 0 0 4 4H19.8"
    />
  </svg>
);
export default SvgArrowCurveUpLeft;
